import { UseQueryResult, useQuery } from "@tanstack/react-query";
import {
  IDashboardGraph,
  IDashboardParams,
  IDashboardTitle,
  IResponseDashboardCentral,
} from "../../interface";
import { axiosCentral, throwResponse } from "config/axios";
import { IResponseCount } from "config/axios/interface";

export const useGetDashboardActivities = (
  params?: IDashboardParams
): UseQueryResult<IResponseCount<IDashboardTitle[]>[], Error> => {
  return useQuery(
    ["dashboard-activity", "count-most-reader", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/activity/count-most-reader",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardActivitiesTime = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardGraph[]>[], Error> => {
  return useQuery(
    ["dashboard-activity", "count-reader-per-mont", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/activity/count-reader-per-month",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
